// 1. 외부 패키지


// 2. 프로젝트 내부 alias


// 3. 상대 경로
import BasicMobileGnbWrapper from "./basic-mobile-gnb-wrapper";
import LeftWrapper from "./left-wrapper";
import RightWrapper from "./right-wrapper";
import TopWrapper from "./top-wrapper";
import BottomWrapper from "./bottom-wrapper";
import Notice from "./notice";
import TableWrapper from "./table-wrapper";
import MobileBottomCardWrapper from "./mobile-bottom-card-wrapper";
import DetailWrapper from "./detail-wrapper";
import PriceInfoWrapper from "./price-info";
import NewsWrapper from "../rt/news-wrapper";

// 4. 타입


const Basic = {
	BasicMobileGnbWrapper,
	LeftWrapper,
	RightWrapper,
	TopWrapper,
	BottomWrapper,
	Notice,
	TableWrapper,
	MobileBottomCardWrapper,
	DetailWrapper,
	PriceInfoWrapper,
	NewsWrapper,
};

export default Basic;